@use '@fukuri-admins/ui/layout' as *;

.PortalSelect__Option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.PortalSelect__TriggerError {
  border-color: border('Red_Darken');
}
